import { ApolloClient, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';

const httpLink = createUploadLink({
    uri: process.env.REACT_APP_API_URL,
    fetchOptions: {
        timeout: 60000,
    },
});

const authLink = setContext((operation, { headers = {} }) => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
            // Requerido por el servidor para peticiones multipart (CSRF): nombre de la operación GraphQL
            ...(operation.operationName && {
                'x-apollo-operation-name': operation.operationName,
            }),
        },
    };
});

const cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                users: {
                    // Crea entradas de caché separadas basadas en filter, sorting, search y paging
                    // Esto asegura que cada página tenga su propia entrada de caché
                    keyArgs: ['filter', 'sorting', 'search', 'paging'],
                },
                administrators: {
                    // Crea entradas de caché separadas basadas en filter, sorting y paging
                    keyArgs: ['filter', 'sorting', 'paging'],
                }
            }
        }
    }
});

export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
    defaultOptions: {
        watchQuery: {
            errorPolicy: 'all',
        },
        query: {
            errorPolicy: 'all',
        },
        mutate: {
            errorPolicy: 'all',
        },
    },
});


